import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import {
  ClickAwayListener,
  Paper,
  MenuItem,
  FormControlLabel,
  Checkbox
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(theme => ({
  menu: {
    position: 'fixed',
    zIndex: 1,
    opacity: 0,
    transform: 'translateY(-10px)',
    transition: 'opacity 0.3s, transform 0.2s'
  },
  menuItem: {
    padding: 0
  },
  formControlLabel: {
    padding: theme.spacing(0.5, 2),
    width: '100%',
    margin: 0
  }
}));

function DropdownMenu({ open, options, onClose, onChange, activeOptions }) {
  const classes = useStyles();

  const menuRef = useRef();
  let transitionFn;

  const handleMenuClose = () => {
    menuRef.current.style.transform = 'translateY(-10px)';
    menuRef.current.style.opacity = 0;
    transitionFn = setTimeout(() => {
      onClose();
    }, 100);
  };

  useEffect(() => {
    transitionFn = setTimeout(() => {
      if (open) {
        menuRef.current.style.transform = 'translateY(0px)';
        menuRef.current.style.opacity = 1;
      }
    }, 0);

    return () => clearTimeout(transitionFn);
  }, [open]);

  return (
    <>
      {open && (
        <ClickAwayListener onClickAway={handleMenuClose}>
          <Paper ref={menuRef} className={classes.menu} elevation={1}>
            {options.map(option => (
              <MenuItem key={option} className={classes.menuItem}>
                <FormControlLabel
                  className={classes.formControlLabel}
                  control={
                    <Checkbox
                      checked={activeOptions.indexOf(option) > -1}
                      onClick={onChange}
                      value={option}
                    />
                  }
                  label={option}
                />
              </MenuItem>
            ))}
          </Paper>
        </ClickAwayListener>
      )}
    </>
  );
}

DropdownMenu.propTypes = {
  open: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.string),
  onClose: PropTypes.func,
  onChange: PropTypes.func,
  activeOptions: PropTypes.arrayOf(PropTypes.string)
};

DropdownMenu.defaultProps = {
  onClose: () => {},
  onChange: () => {}
};

export default DropdownMenu;
